import React, { useState, useEffect } from 'react';
import './News.css';
import { Link } from 'react-router-dom';
import { newsItems } from '../data/newsData';

const News = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  


  // Check screen size and update state
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const cardsPerView = isMobile ? 1 :4; // Number of cards visible at once
  const maxIndex = Math.max(0, newsItems.length - cardsPerView);

  const goToPrevious = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex(prev => Math.min(maxIndex, prev + 1));
  };

  // Calculate translate value based on screen size
  const getTranslateValue = () => {
    if (isMobile) {
      return `calc((-100% - 10px) * ${currentIndex})`; // n = 1(items per view);gap=10px; formula = (100/n)% (gap/n)
    } else {
      return `calc((-25% - 5px) * ${currentIndex})`; // n = 4(items per view);gap=20px; formula = (100/n)% (gap/n)
    }
  };

  return (
    <section className="news section">
      <div className="container">
        <h2 className="section-title">News and Updates</h2>
        
        <div className="news-container">
          {/* Desktop Navigation - Side by side with news track */}
          <div className="desktop-nav">
            <button 
              className="nav-btn prev" 
              onClick={goToPrevious}
              disabled={currentIndex === 0}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </div>
          
          <div className="news-track">
            <div 
              className="news-grid"
              style={{
                transform: `translateX(${getTranslateValue()})`
              }}
            >
              {newsItems.map((item) => (
                  <div key={item.id} className="news-card">
                <Link to={`/news/${item.id}`} key={item.id}>
                    <div className="news-image">
                      <i className="fas fa-newspaper"></i>
                    </div>
                    <div className="news-content">
                      <h3>{item.title}</h3>
                      <p>{item.excerpt}</p>
                      <span className="news-date">{item.date}</span>
                    </div>
                </Link>
                  </div>
              ))}
            </div>
          </div>
          
          <div className="desktop-nav">
            <button 
              className="nav-btn next" 
              onClick={goToNext}
              disabled={currentIndex === maxIndex}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
        
        {/* Mobile Navigation - Below news cards */}
        <div className="mobile-nav">
          <button 
            className="nav-btn prev" 
            onClick={goToPrevious}
            disabled={currentIndex === 0}
          >
            <i className="fas fa-chevron-left"></i>
          </button>
          <button 
            className="nav-btn next" 
            onClick={goToNext}
            disabled={currentIndex === maxIndex}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
        
        {/* See More Button - Below navigation buttons */}
        {/* <div className="news-actions">
          <button className="btn btn-primary">
            See More
            <div className="action-icon">
              <i className="fas fa-arrow-right"></i>
            </div>
          </button>
        </div> */}
      </div>
    </section>
  );
};

export default News;
